import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock, Mail } from 'lucide-react';
import { Container } from '../../components/layout/Container';
import { Button } from '../../components/ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { useToast } from '../../contexts/ToastContext';
import { adminLogin } from '../../lib/api';

export function AdminLogin() {
  const navigate = useNavigate();
  const { error: showError, success: showSuccess } = useToast();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      showError('Please enter email and password');
      return;
    }

    setIsLoading(true);

    try {
      const session = await adminLogin(email, password);
      showSuccess(`Welcome back, ${session.admin.email}`);
      navigate('/admin');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Login failed';
      showError(message === 'Invalid credentials' ? 'Invalid email or password' : message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Container size="sm">
        <Card className="max-w-md mx-auto">
          <CardHeader className="text-center">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ backgroundColor: 'rgba(0, 150, 136, 0.1)' }}
            >
              <Shield className="w-8 h-8" style={{ color: '#009688' }} />
            </div>
            <CardTitle>Snapshot Admin</CardTitle>
            <p className="text-gray-600 mt-2">
              Sign in to manage snapshots and invites
            </p>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <Input
                label="Email"
                type="email"
                placeholder="admin@asiliguide.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                leftIcon={<Mail className="w-4 h-4 text-gray-400" />}
              />
              <Input
                label="Password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                leftIcon={<Lock className="w-4 h-4 text-gray-400" />}
              />
              <Button
                type="submit"
                className="w-full"
                isLoading={isLoading}
              >
                Sign In
              </Button>
            </form>

            <div className="mt-6 text-center text-sm text-gray-500">
              <p>
                Need access?{' '}
                <a
                  href="mailto:support@getasili.com"
                  className="hover:opacity-80"
                  style={{ color: '#009688' }}
                >
                  Contact support
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
